<template>
  <div>
    <div class="flex-content-2">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in activitiesSys"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activeNamesSys.includes(String(index)) ? '#1286FF' : ''"
          :size="activity.size">
          <el-collapse v-model="activeNamesSys">
            <el-collapse-item :title="activitiesSys[index].title" :name="String( index )" :class="{ 'active': (index + 1) % 2 === 0, 'not-active': (index + 1) % 2 !== 0 }">
              <tabsCommon :detail="activitiesSys[index].details" />
            </el-collapse-item>
          </el-collapse>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="pages-list">
      <ELpagination :currentPage="pageInfoSys.pageNum" :total="pageInfoSys.total" :limit="pageInfoSys.pageSize" :small="true" @handleCurrentChange="handleCurrentChangeSys" @handleSizeChange="handleSizeChangeSys"/>
    </div>
  </div>
</template>

<script>
  import tabsCommon from "./tabsCommon"
  import ELpagination from "../../common/ELpagination"
  // import { Logs } from "@/graphql/PiPLogs.gql"

  export default {
    components: {
			tabsCommon,
			ELpagination
		},
    data () {
      return {
        activitiesSys: [],
				activeNamesSys: [ "0", "1", "2" ],
        pageInfoSys: {
					total: 0,
					pageSize: 10,
					pageNum: 1
				}
      }
    },
    created () {
      this.getUpdate()
      const urlSys = "https://api-project.itheima.net/pip-logs/count?type_eq=system"
      this.$axios.get(urlSys).then(res => {
        this.pageInfoSys.total = res.data
      }).catch(() => {})
    },
    methods: {
      handleCurrentChangeSys (val) {
        this.pageInfoSys.pageNum = val
        this.getUpdate()
      },
      handleSizeChangeSys (val) {
        this.pageInfoSys.pageSize = val
        this.pageInfoSys.pageNum = 1
        this.getUpdate()
      },
      getUpdate () {
        const { pageSize, pageNum } = this.pageInfoSys
				// this.$apollo.query(
        // {
        //   query: Logs,
        //   variables: {
        //     isPublish: true,
        //     type: "system",
				// 		limit: pageSize,
				// 		start: (pageNum - 1) * pageSize || 0
        //   },
        // })
        // .then((res) => {
				// 	this.activitiesSys = [ ...res.data.pipLogs ]
        // })
        // .catch(() => {
        // })
        this.$axios.get(`https://api-project.itheima.net/pip-logs?_start=${(pageNum - 1) * pageSize}&_limit=${pageSize}&_sort=id:desc&type_eq=system`).then(res => {
          this.activitiesSys = [ ...res.data ]
        })
			}
    }
  }
</script>

<style lang="scss" src="../../../../../styles/updateProject.scss">
</style>